import { cn } from "../lib/cn";

export type StampTone = "accent" | "working" | "stopped";

const toneClasses: Record<StampTone, string> = {
  accent: "border-accent-deep text-accent-deep",
  working: "border-ink-working text-ink-working",
  stopped: "border-ink-stopped text-ink-stopped",
};

export interface StampProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: StampTone;
  animateIn?: boolean;
  children: React.ReactNode;
  ref?: React.Ref<HTMLSpanElement>;
}

/** A mark a person left on a record (sign-off, approval); never a computed status. */
export function Stamp({
  tone = "accent",
  animateIn = false,
  className,
  children,
  ref,
  ...rest
}: StampProps) {
  return (
    <span
      ref={ref}
      className={cn(
        "inline-block border-2 bg-transparent px-2 py-0.5 rounded-[2px]",
        "font-mono uppercase text-[0.6875rem] font-medium tracking-[0.13em]",
        "[mask-image:radial-gradient(ellipse_at_center,black_60%,rgba(0,0,0,0.72)_100%)]",
        toneClasses[tone],
        animateIn &&
          "[animation:bds-stamp_260ms_var(--ease-paper)_both] motion-reduce:animate-none",
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
